import { ConsentType } from '@/enums'

export const consentLabelByType: Record<ConsentType, string> = {
  [ConsentType.ClientDataProcessing]: 'MetabolicLang.addClient.acceptConsent',
  [ConsentType.ClientUseOfPseudonymizedData]: 'MetabolicLang.addClient.acceptData',
  [ConsentType.ClientMarketing]: 'MetabolicLang.addClient.acceptMarketing',
  [ConsentType.JCA]: 'JCA',
  [ConsentType.DPA]: 'DPA',
  [ConsentType.ClientDataUseInApp]: 'MetabolicLang.Legal.ConsentDataUseAppLabel',
}
